module.exports = __webpack_public_path__ + "img/avatar.ef41d997.png";